var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New Onboarding flow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5656 -959C-5656 -960.105 -5655.1 -961 -5654 -961H15995C15996.1 -961 15997 -960.105 15997 -959V1624C15997 1625.1 15996.1 1626 15995 1626H-5654C-5655.1 1626 -5656 1625.1 -5656 1624V-959Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5654 -960H15995V-962H-5654V-960ZM15996 -959V1624H15998V-959H15996ZM15995 1625H-5654V1627H15995V1625ZM-5655 1624V-959H-5657V1624H-5655ZM-5654 1625C-5654.55 1625 -5655 1624.55 -5655 1624H-5657C-5657 1625.66 -5655.66 1627 -5654 1627V1625ZM15996 1624C15996 1624.55 15995.6 1625 15995 1625V1627C15996.7 1627 15998 1625.66 15998 1624H15996ZM15995 -960C15995.6 -960 15996 -959.552 15996 -959H15998C15998 -960.657 15996.7 -962 15995 -962V-960ZM-5654 -962C-5655.66 -962 -5657 -960.657 -5657 -959H-5655C-5655 -959.552 -5654.55 -960 -5654 -960V-962Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile Page - All",
    clipPath: "url(#clip0_5865_5987)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1025,
    transform: "translate(-703 -541)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4899"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 326",
    x: -426,
    y: 7,
    width: 622,
    height: 72,
    rx: 4,
    fill: "#F9F9F9"
  }))))))))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1071",
    x: -452,
    y: -407,
    width: 1189,
    height: 891,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1072",
    x: -99.5,
    y: -357.5,
    width: 481,
    height: 623,
    rx: 9.5,
    fill: "white",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5166"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5481"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1069",
    x: -16,
    y: -34,
    width: 314,
    height: 96,
    rx: 4,
    fill: "#FFEEC4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9104219_warning_danger_attention_caution_alert_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2008 16.5002L14.6008 4.7002C14.1008 3.7002 13.1008 3.2002 12.0008 3.2002C10.9008 3.2002 9.90078 3.7002 9.40078 4.7002L2.80078 16.5002C2.30078 17.4002 2.30078 18.6002 2.80078 19.5002C3.30078 20.4002 4.30078 21.0002 5.40078 21.0002H18.6008C19.7008 21.0002 20.6008 20.4002 21.2008 19.5002C21.8008 18.6002 21.7008 17.5002 21.2008 16.5002ZM19.5008 18.5002C19.4008 18.6002 19.2008 19.0002 18.6008 19.0002H5.40078C4.90078 19.0002 4.60078 18.7002 4.50078 18.5002C4.40078 18.3002 4.20078 18.0002 4.50078 17.5002L11.1008 5.6002C11.4008 5.1002 11.8008 5.1002 12.0008 5.1002C12.2008 5.1002 12.6008 5.1002 12.9008 5.6002L19.5008 17.5002C19.7008 18.0002 19.5008 18.4002 19.5008 18.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 9C11.4 9 11 9.4 11 10V13C11 13.6 11.4 14 12 14C12.6 14 13 13.6 13 13V10C13 9.4 12.6 9 12 9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "black"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Connector line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M347.5 -306C347.5 -306.828 346.828 -307.5 346 -307.5C345.172 -307.5 344.5 -306.828 344.5 -306H347.5ZM15.9393 549.061C16.5251 549.646 17.4749 549.646 18.0607 549.061L27.6066 539.515C28.1924 538.929 28.1924 537.979 27.6066 537.393C27.0208 536.808 26.0711 536.808 25.4853 537.393L17 545.879L8.51472 537.393C7.92893 536.808 6.97919 536.808 6.3934 537.393C5.80761 537.979 5.80761 538.929 6.3934 539.515L15.9393 549.061ZM344.5 -306V423H347.5V-306H344.5ZM322 445.5H41V448.5H322V445.5ZM15.5 471V548H18.5V471H15.5ZM41 445.5C26.9167 445.5 15.5 456.917 15.5 471H18.5C18.5 458.574 28.5736 448.5 41 448.5V445.5ZM344.5 423C344.5 435.426 334.426 445.5 322 445.5V448.5C336.083 448.5 347.5 437.083 347.5 423H344.5Z",
    fill: "#F42E33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5865_5987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1025,
    fill: "white",
    transform: "translate(-703 -541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attentionIcon.ad5eb48f02ba7d6d9e256256a6c630e7.svg";
export { ForwardRef as ReactComponent };